import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGoogleAdsInit } from "@/ads/hooks/useGoogleAdsInit";
import { BottomSection, FarbweltStickyBanner, Gallery, MainColumn, Plato, Sections, TopBar, } from "@/components";
import { LeaderBoard } from "@/components/Ads";
import { Breadcrumb } from "@/components/Breadcrumb";
import { ContactCardColumn, StickyCta } from "@/components/contacting";
import { FeedbackSurvey } from "@/components/FeedbackSurvey";
import { SimilarListings } from "@/components/SimilarListings";
import { OpenFormStickyBanner } from "@/components/utilsComponents/openFormStickyBanner/OpenFormStickyBanner";
import { useConfig } from "@/contexts/cdpConfig";
import { useFeaturesEnabled } from "@/contexts/cdpConfig/hooks";
import { useClassifiedId } from "@/contexts/classified";
import { useCustomerActionExposeSectionView, useFarbwelt, useTestId, useTrackingLegacyView, useTrackingView, } from "@/hooks";
import { useClassifiedAnalyticsView } from "@/hooks/tracking/classifiedAnalytics";
import { PrintTemplateCss } from "@/templates/PrintTemplateCss";
import { saveSeenToStorage } from "@/utils/saveContactAndSeenToStorage/saveContactAndSeenToStorage";
import { useEffect, useState } from "react";
import { CdpPreviewTemplateCSS } from "./CdpPreviewTemplateCss";
import { Wrapper } from "./Wrapper";
export const Template = () => {
    const testId = useTestId("main");
    const [loadPrintTemplate, setLoadPrintTemplate] = useState(false);
    const isOpenContactForm = useFeaturesEnabled().openedContactForm;
    const { isFarbweltActive } = useFarbwelt();
    const isPreviewMode = useConfig().previewMode;
    const classifiedId = useClassifiedId();
    useEffect(() => {
        saveSeenToStorage(classifiedId);
    }, [classifiedId]);
    useEffect(() => {
        setLoadPrintTemplate(true);
    }, []);
    // Legacy tracking solution on French brands also known as "Harvest"
    useTrackingLegacyView();
    useTrackingView();
    // wl classified analytics call
    useClassifiedAnalyticsView();
    useGoogleAdsInit();
    // Legacy tracking solution on German brands
    useCustomerActionExposeSectionView();
    return (_jsxs(_Fragment, { children: [isPreviewMode ? _jsx(CdpPreviewTemplateCSS, {}) : null, isOpenContactForm ? (_jsx(OpenFormStickyBanner, {})) : (isFarbweltActive && _jsx(FarbweltStickyBanner, {})), _jsx(LeaderBoard, {}), _jsxs(Wrapper, { testId: testId, children: [loadPrintTemplate && _jsx(PrintTemplateCss, {}), _jsx(TopBar, {}), _jsxs(MainColumn, { children: [_jsx(Gallery, {}), _jsx(Sections, {})] }), _jsx(ContactCardColumn, {}), _jsx(FeedbackSurvey, {}), _jsx(SimilarListings, {}), _jsx(Breadcrumb, {}), _jsx(BottomSection, {}), _jsx(StickyCta, { tracking: { avZone: "sticky" } })] }), _jsx(Plato, {})] }));
};
